// Local translations
export const T = {
  en_GB: {
    paragraph: "Paragraph",
    heading: "Heading",
    heading1: "Heading 1",
    heading2: "Heading 2",
    heading3: "Heading 3",
    quote: "Quote",
    bulletList: "Bullet List",
    numberedList: "Numbered List",
    undo: "Undo",
    redo: "Redo",
    bold: "Bold",
    italic: "Italic",
    startVoiceRecording: "Voice to text (Voxtral)",
    stopVoiceRecording: "Stop & transcribe",
    transcribing: "Transcribing…",
    voiceError: "Transcription failed. Please try again.",
    micDenied: "Microphone access was denied.",
    transcriptionLanguage: "Transcription language",
    aiTextImprovement: "AI text improvement",
    improveWriting: "Improve Writing",
    simplify: "Simplify",
    expandDetail: "Expand Detail",
    makeFormal: "Make Formal",
    makeConcise: "Make Concise",
    pleaseEnterTextFirst: "Please enter some text first",
    failedToImproveText: "Failed to improve text. Please try again.",
  },
  nb_NO: {
    paragraph: "Avsnitt",
    heading: "Overskrift",
    heading1: "Overskrift 1",
    heading2: "Overskrift 2",
    heading3: "Overskrift 3",
    quote: "Sitat",
    bulletList: "Punktliste",
    numberedList: "Nummerert liste",
    undo: "Angre",
    redo: "Gjenta",
    bold: "Fet",
    italic: "Kursiv",
    startVoiceRecording: "Tale til tekst (Voxtral)",
    stopVoiceRecording: "Stopp og transkriber",
    transcribing: "Transkriberer…",
    voiceError: "Transkripsjon feilet. Prov igjen.",
    micDenied: "Mikrofontilgang ble avvist.",
    transcriptionLanguage: "Transkripsjonsspråk",
    aiTextImprovement: "AI-tekstforbedring",
    improveWriting: "Forbedre skriving",
    simplify: "Forenkle",
    expandDetail: "Utvid detaljer",
    makeFormal: "Gjor formell",
    makeConcise: "Gjor kortfattet",
    pleaseEnterTextFirst: "Skriv inn tekst forst",
    failedToImproveText: "Kunne ikke forbedre teksten. Prov igjen.",
  },
} as const;
